import UserListArea from "./UserListArea.js";
import ConfirmationArea from "./ConfirmationArea.js";

import Menu from "../Menu.js";

import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.ResourcesEditArea");
log.setLevel(log.levels.WARN);

let ResourcesEditArea = function () {
    let svg;
    var tools = global.tools;
    var scene = global.scene;
    var selected = null;

    // We play the stream linked to the resource when dblclick
    $("body").on("dblclick", "#map_area svg g.node.resource", async (event) => {
        await this.double_click_interact({attachment: event.currentTarget});
    });

    Object.defineProperty(this, "selected", {
        set: () => {},
        get: () => selected
    });

    const unselect = () => {
        log.debug("ResourceEditorArea.unselect");
        if (selected === null) {
            return;
        }
        scene.shadow.unaffect(selected.handle);
        selected = null;
    };

    const select = (node) => {
        log.debug("ResourcesEditArea.select:", node);
        if (selected !== null && selected !== undefined) {
            //fix for AGPOC-2995
            unselect();
        }
        selected = scene.objects.get_by_node("resources", node);
        scene.shadow.affect(selected.handle);
    };

    this.select = async (handle) => {
        log.debug("ResourceEditorArea.select");
        if (global.scene.mode_switcher.mode !== "resources") {
            return;
        }
        await Menu.close("resources_edit_area");
        select(handle);
        let color_value = $(selected.node.node()).children(".color").first().children(".color").attr("fill");
        if (color_value in global.resources.color_by_value) {
            let color = global.resources.color_by_value[color_value];
            tools.group_select("resources_color_update", `resource_color_${color.name}`);
        }
        await Menu.display(["resources_edit_area"]);
    };

    let date_format = (time) => {
        log.debug("time", time);
        if (global.configuration.user.agnet === undefined) {
            let time_date = new Date(time / 1000);
            log.debug("time_date ", time_date);
            return `(${global.internationalization.formatDateWithYear(time_date)} ${global.internationalization.formatTimeWithSeconds(time_date)})`;
        } else {
            let year = time.slice(0, 4);
            let month = time.slice(4, 6);
            let day = time.slice(6, 8);
            let hour = time.slice(9, 11);
            let min = time.slice(12, 14);
            let sec = time.slice(15);

            var time_date = new Date(Date.UTC(year, month - 1, day, hour, min, sec));
            log.debug("time_date ", time_date);
            return `(${global.internationalization.formatDateWithYear(time_date)} ${global.internationalization.formatTimeWithSeconds(time_date)})`;
        }
    };

    let init_resource_info = () => {
        log.debug("ResourcesEditorArea.init_resource_info in");
        // Initialize resource info area
        let resource_area = $("<div />").attr({id: "resource_area"});

        // column 1: icon
        $("<div />").attr({id: "resource_picture_area"}).appendTo(resource_area);

        // column 2: text infos
        let resource_info_area = $("<div />").attr({id: "resource_info_area"}).appendTo(resource_area);

        // column 2, raw 1: device status, battery level, signal strenght
        let row1 = $("<div />").attr({id: "resource_info_device"}).appendTo(resource_info_area);
        $("<span />").attr({id: "user_name"}).appendTo(row1);
        $("<canvas />").attr({id: "user_canvas", width: "10", height: "10"}).appendTo(row1);

        let device_status = $("<div />").attr({id: "device_status"}).appendTo(row1);

        let battery_level = $("<div />").attr({id: "battery_level"}).appendTo(device_status);
        $("<i />").attr({id: "battery_level_icon"}).appendTo(battery_level);
        $("<span></span>").attr({id: "battery_level_value"}).appendTo(battery_level);

        let network = $("<div />").attr({id: "network"}).appendTo(device_status);
        // signal strength icon divided in 2 icons in order to manage color and levels
        $("<i />").attr({id: "signal_background"}).appendTo(network);
        $("<i />").attr({id: "signal_strength"}).appendTo(network);

        // column 2, raw 2: geolocation
        let row2 = $("<div />").attr({id: "resource_info_geo"}).appendTo(resource_info_area);
        $("<i />").attr({id: "device_geolocation_status", class: "f_mtac-icon-location"}).appendTo(row2);
        $("<span></span>").attr({id: "device_geolocation_coords"}).appendTo(row2);
        $("<span></span>").attr({id: "device_geolocation_date", class: "small"}).appendTo(row2);

        return resource_area;
    };

    let show_resource_icon = () => {
        if (svg === undefined) {
            // init the svg viewbox
            svg = global.d3.select("#resource_picture_area").append("svg").attr("viewBox", "20 20 160 160");
        } else {
            // clean previous icon
            svg.html("");
        }
        let icon = selected.handle.select("g.figure").node().cloneNode(true);
        svg.append(() => icon);
    };

    let hide_username = () => {
        $("#resource_info_area span#user_name").text("");
    };

    let hide_geoloc_status = () => {
        let canvas = document.getElementById("user_canvas");
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    };
    let show_geoloc_status = () => {
        // Add a small circle with the appropriate color
        let color = global.resources.get_status_color(selected.node);
        log.debug("ResourcesEditorArea.show_geoloc_status", {color});
        if (color != null) {
            let canvas = document.getElementById("user_canvas");
            var ctx = canvas.getContext("2d");
            ctx.beginPath();
            ctx.arc(5, 5, 5, 0, 2 * Math.PI, false); // "5" because canvas width=height= 10
            ctx.fillStyle = color;
            ctx.fill();
            ctx.strokeStyle = "#003300";
            ctx.stroke();
        }
    };

    let hide_battery_level = () => {
        $("#resource_info_area i#battery_level_icon").removeClass("f_mtac-icon-battery-solid");
        $("#resource_info_area i#battery_level_icon").removeClass("very-low");
        $("#resource_info_area i#battery_level_icon").removeClass("low");
        $("#resource_info_area span#battery_level_value").text("");
    };

    let show_battery_level = () => {
        let battery_level = selected.node.attr("data-battery");
        log.debug("battery level", battery_level);
        if (battery_level === null) {
            return;
        }
        $("#resource_info_area span#battery_level_value").text(selected.node.attr("data-battery"));
        $("#resource_info_area i#battery_level_icon").addClass("f_mtac-icon-battery-solid");

        if (battery_level < 10) {
            $("#resource_info_area i#battery_level_icon").addClass("very-low");
        } else if (battery_level < 20) {
            $("#resource_info_area i#battery_level_icon").addClass("low");
        } else {
            $("#resource_info_area i#battery_level_icon").removeClass("very-low");
            $("#resource_info_area i#battery_level_icon").removeClass("low");
        }
        if (battery_level === "-1") {
            $("#resource_info_area span#battery_level_value").text("?");
        }
    };

    let hide_signal_strength = () => {
        $("#resource_info_area i#signal_background").removeClass("f_mtac-icon-signal-very-strong");
        for (const strength of ["very-poor", "poor", "medium", "strong", "very-strong"]) {
            $("#resource_info_area i#signal_strength").removeClass(`f_mtac-icon-signal-${strength}`);
        }
    };

    let show_signal_strength = () => {
        let signal_strength = selected.node.attr("data-signal");
        log.debug("datasignal", signal_strength);
        if (signal_strength === null) {
            return;
        }

        const signal_strength_list = {
            0: "f_mtac-icon-signal-very-poor",
            1: "f_mtac-icon-signal-poor",
            2: "f_mtac-icon-signal-medium",
            3: "f_mtac-icon-signal-strong",
            4: "f_mtac-icon-signal-very-strong"
        };
        try {
            $("#resource_info_area i#signal_strength").addClass(signal_strength_list[signal_strength]);
        } catch (error) {
            log.error(`Unknown signal strength value of ${signal_strength}`);
        }
        $("#resource_info_area i#signal_background").addClass("f_mtac-icon-signal-very-strong");
    };

    let hide_geolocation = () => {
        $("#resource_info_area i#device_geolocation_status").hide();
        $("#resource_info_area span#device_geolocation_coords").text("");
        $("#resource_info_area span#device_geolocation_date").text("");
    };

    let show_geolocation = () => {
        if (global.storage.selected_context.projection.project_invert === null) {
            return;
        }

        // display icon
        $("#resource_info_area i#device_geolocation_status").show();

        // display coordinates
        let coords;
        if (selected.node.attr("data-latitude") !== null) {
            // Linked to an Agnet user
            coords = selected.node.attr("data-latitude") + ", " + selected.node.attr("data-longitude");
        } else {
            // For georeferenced SITAC, calculate longitude/latitude from resource position
            let [X, Y] = selected.node.attr("transform").split(/[(,)]/).slice(1, 3);
            log.debug("[X, Y]:", [X, Y]);
            // Add 100 to pixel coordinates as it is done in get_object_translate in Users.js
            let [X1, Y1] = [parseInt(X) + 100, parseInt(Y) + 100];
            let [E, N] = global.storage.selected_context.projection.project_invert([X1, Y1]);
            coords = N.toFixed(6) + ", " + E.toFixed(6);
        }
        log.debug("Coordinates:", coords);
        $("#resource_info_area span#device_geolocation_coords").text(coords);

        // display last geolocation time (Agnet user only)
        let time = selected.node.attr("data-last-geoloc-time");
        log.debug("Last geoloc time:", time);
        if (time !== null) {
            $("#resource_info_area span#device_geolocation_date").text(date_format(time));
        }
    };

    this.init = function () {
        tools = global.tools;
        scene = global.scene;

        // AGPOC-6677: Initialize resource info area
        let resource_info_area = init_resource_info();
        let tools_list;
        if (global.configuration.user.agnet !== undefined) {
            // Remove device association tool for Agnet user.
            tools_list = ["#resources_edit_options", "#resources_edit_colors", "#resources_edit_copy", "#resources_edit_delete"];
        } else {
            tools_list = ["#resources_edit_options", "#resources_edit_colors", "#resources_edit_mobile", "#resources_edit_copy", "#resources_edit_delete"];
        }

        Menu.create({
            name: "resources_edit_area",
            icon: "resources",
            contents: tools_list,
            frame_content: resource_info_area,
            open_handler: () => {
                log.debug("ResourceEditorArea.open_handler");
                global.scene.disable_draggable_tools();

                if (selected.handle.select("g.animated_resource").node() !== null) {
                    // Disable color modification for animated resource
                    global.tools.groups["resources_color_update"].disable();
                } else {
                    global.tools.groups["resources_color_update"].enable();
                }

                if (selected.node.attr("data-msisdn") !== null) {
                    // Hide unavailable tools for Agnet resource
                    global.tools.tools["resource_rename"].$button.hide();
                    global.tools.tools["resource_copy"].$button.parent().hide();
                    global.tools.tools["resource_delete"].$button.parent().hide();
                } else {
                    global.tools.tools["resource_rename"].$button.css("display", null);
                    global.tools.tools["resource_copy"].$button.parent().css("display", null);
                    global.tools.tools["resource_delete"].$button.parent().css("display", null);
                }

                hide_username();
                hide_geoloc_status();
                hide_signal_strength();
                hide_battery_level();
                hide_geolocation();

                show_resource_icon();

                // display user's name / resource's label
                let resource_label = global.resources.name(selected.node);
                let user_name = global.resources.user_name(selected.node);
                if (user_name && resource_label) {
                    $("#resource_info_area span#user_name").text(`${user_name} / ${resource_label} `);
                } else if (user_name && !resource_label) {
                    $("#resource_info_area span#user_name").text(`${user_name} `);
                } else if (resource_label) {
                    $("#resource_info_area span#user_name").text(`${resource_label} `);
                }

                // display linked device info (Agnet user) or geoloc_status (standalone user)
                if (user_name) {
                    log.debug("user_name", user_name);
                    // Resource linked to a user
                    if (global.configuration.user.agnet) {
                        // Agnet user -> display battery and signal
                        show_battery_level();
                        show_signal_strength();
                    } else {
                        // Standalone user -> display name and geolocation status
                        // Stick the color circle just after the text
                        document.getElementById("resource_info_device").style.justifyContent = "flex-start";
                        show_geoloc_status();
                    }
                }

                show_geolocation();
            },
            close_handler: () => {
                log.debug("ResourceEditorArea.close_handler");
                unselect();
                if (global.scene.objects.layers.media.ids.length > 0) {
                    global.scene.enable_draggable_tools();
                }
                global.tools.tools["grid_move"].disable();
            },
            close_timer: true
        });

        tools.register({
            name: "resource_rename",
            icon: "rename",
            position: "#resources_edit_options",
            handler: () => {
                let object = selected;
                global.resources.request_name(object.handle).then((resource_name_text) => {
                    if (resource_name_text === null) {
                        return;
                    }
                    scene.objects.tx_update("resources", object);
                });
            }
        });

        tools.register({
            name: "resource_center",
            icon: "recenter",
            position: "#resources_edit_options",
            handler: () => {
                if (global.scene.tracking.tracked === selected.id) {
                    global.scene.tracking.untrack();
                    return;
                }
                global.scene.tracking.track(selected.id);
            }
        });

        tools.register_group({
            name: "resources_color_update",
            target: "$none",
            enable: (_, selected_tool) => {
                let object = selected;
                // update is sent each time we open the resource menu!!!
                // fix : send update only when it's needed (color changed)
                if (selected_tool.data.color.value != object.handle.select("g.color").select("circle.color").attr("fill")) {
                    global.resources.color(object.node, selected_tool.data.color.value);
                    global.scene.objects.tx_update("resources", object);
                }
            },
            disable: () => {}
        });

        global.resources.colors.forEach((color) => {
            tools.register({
                group: "resources_color_update",
                name: `resource_color_${color.name}`,
                data: {color},
                icon: "drop_black",
                position: "#resources_edit_colors",
                style: {color: color.value, "text-stroke": "1px #fff"}
            });
        });

        // association tool unavailable to agnet user
        if (global.configuration.user.agnet === undefined) {
            tools.register({
                name: "resource_mobile",
                icon: "phone",
                position: "#resources_edit_mobile",
                handler: async () => {
                    var linked_resource = selected;
                    if (linked_resource.node.attr("data-user") === null) {
                        var user = await UserListArea.interact();
                        if (user === null) {
                            return;
                        }
                        linked_resource.node.attr("data-user", user.login);
                        linked_resource.node.attr("data-last-geoloc-time", null);
                        global.resources.user_name(linked_resource.handle, user.name);
                        await global.scene.objects.tx_update("resources", linked_resource);
                        global.users.position_refresh();
                    } else {
                        let confirmation = await ConfirmationArea.interact({
                            title: global.internationalization.text("resource.Release"),
                            tip1: global.internationalization.text("resource.Release-resource")
                        });
                        if (!confirmation) {
                            return;
                        }
                        linked_resource.node.attr("data-user", null);
                        linked_resource.node.attr("data-last-geoloc-time", null);
                        global.resources.user_name(linked_resource.handle, "");
                        global.scene.objects.tx_update("resources", linked_resource);
                    }
                }
            });
        }

        tools.register({
            name: "resource_stream",
            icon: "video",
            position: "#resources_stream",
            handler: async () => {
                var linked_resource = selected; // selected is a Interaction class
                let stream_node = $(linked_resource.handle.select(".stream").node()); // Using the Interaction we fetch the cash-dom element
                // Checking if the resource is already linked
                if (stream_node.children().length === 0) {
                    await global.resources.request_stream_url(linked_resource.handle).then((user_stream_url) => {
                        if (user_stream_url === null || user_stream_url == "") {
                            return;
                        }
                        global.scene.objects.tx_update("resources", linked_resource);
                    });
                } else {
                    let confirmation = await ConfirmationArea.interact({
                        title: global.internationalization.text("resource.Release"),
                        tip1: global.internationalization.text("resource.Floater-stream-release")
                    });
                    if (!confirmation) {
                        return;
                    }
                    stream_node.empty();
                    stream_node.removeAttr("data-stream_url");
                    $($(document.body).find("#floater_area #" + linked_resource.handle.attr("id"))).remove();
                    global.scene.objects.tx_update("resources", linked_resource);
                }
            }
        });

        tools.register({
            name: "resource_copy",
            icon: "duplicate",
            position: "#resources_edit_copy",
            handler: () => {
                let old_object = selected;
                let new_object = scene.objects.duplicate("resources", old_object);
                let angle = Math.random() * 2 * Math.PI;
                new_object.move({
                    x: (50 * Math.cos(angle)) / scene.root_transform.k,
                    y: (50 * Math.sin(angle)) / scene.root_transform.k
                });
                let name = global.resources.name(new_object.handle);
                if (name !== undefined && name !== "") {
                    global.resources.name(new_object.handle, name + " " + global.internationalization.text("resource.copy"));
                }
                return global.resources
                    .request_name(new_object.handle)
                    .then((name) => {
                        if (name === null) {
                            scene.objects.layers["resources"].remove(new_object.id);
                            new_object = null;
                            return;
                        }
                        return scene.objects.publish("resources", new_object);
                    })
                    .then(() => {
                        if (new_object !== null) {
                            this.select(new_object.handle.node());
                        }
                    });
            }
        });

        tools.register({
            name: "resource_delete",
            icon: "suppp",
            position: "#resources_edit_delete",
            handler: () => {
                ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("resource.Delete-resource")
                }).then((confirmed) => {
                    if (!confirmed) {
                        return;
                    }
                    let object = selected;
                    scene.objects.tx_delete("resources", object);
                    $($(document.body).find("#floater_area #" + object.handle.attr("id"))).remove();

                    // hide the toolbar immediately
                    Menu.close("resources_edit_area");
                });
            }
        });
    };
    window.addEventListener("f_mtac.init", () => {
        this.init();
    });

    let interaction_end = () => {
        Menu.close("resources_edit_area");
    };

    this.interact = async function () {
        await Menu.close("resources_edit_area");
        await Menu.display(["resources_edit_area"]);
        return new Promise((resolve) => {
            $("body").on("click.resources_edit_area", "#resources_edit_area .btn-menu-close", () => {
                log.debug("ResourceEditorArea.interact: Close button pressed!");
                interaction_end();
                resolve(null);
            });
        });
    };

    /**
     * @brief When double_click is executed on a resource that is linked with a stream, we open a single instance of a stream_player
     * @param HTML_Element attachment
     * @returns
     */
    this.double_click_interact = async ({attachment}) => {
        log.debug("ResourcesEditArea.double_click_interact", attachment);
        await global.scene.floaters.create("stream", attachment);
    };
};
export default new ResourcesEditArea();
